import {existsOrDefault} from "../util/util"

const getVariant = function (status) {
    if (status === "whitelist")
        return "success";
    if (status === "blacklist")
        return "danger";
    if (status === "exploration")
        return "info";
    if (status === "many")
        return "secondary";
    return null;
}

const getDefaultTemplates = function () {
    let defaultTemplate = {
        name: "Default",
        metrics: this.defaultCheckedMetrics,
        dimensions: this.defaultCheckedCols,
        dimensionFilters: [],
        metricFilters: [],
        interval: 7,
        filters: [],
    };
    let wlTemplate = {
        name: "whitelist",
        metrics: this.defaultCheckedMetrics,
        dimensions: this.defaultCheckedCols,
        interval: 7,
        filters: [],
    };
    let blTemplate = {
        name: "blacklist",
        metrics: this.defaultCheckedMetrics,
        dimensions: this.defaultCheckedCols,
        interval: 7,
        filters: [],
    };
    let explrTemplate = {
        name: "exploration",
        metrics: this.defaultCheckedMetrics,
        dimensions: this.defaultCheckedCols,
        interval: 7,
        filters: [],
    };

    return [defaultTemplate, wlTemplate, blTemplate, explrTemplate]
}

const PARAMS = {context : "context", dims : "dims", startDate:"start_date", endDate:"end_date", sortBy:"sort_by",
    sortOrder: "sort_order", filterRaw:"filter_raw", demoUid:"demo_uid", pageNum:"page_num", pageSize:"page_size",
    serviceTemplate: "service_template", metrics: "metrics", name: "name", ab: "ab"
}

const ROUTES = {ts:"ts", query: "query", csv:"csv", schema:"schema", templates:"templates", dbOps:"db-ops", insights:"insights", als:"dbals", uals:"userals"}

const getParamMap = function (filter_arr) {
    let paramMap = new Map()
    paramMap.set(PARAMS.context, existsOrDefault(this.context))
    paramMap.set(PARAMS.dims, existsOrDefault(this.checkedCols, []).join(","))
    paramMap.set(PARAMS.startDate, existsOrDefault(this.startDate))
    paramMap.set(PARAMS.endDate, existsOrDefault(this.endDate))
    paramMap.set(PARAMS.sortBy, existsOrDefault(this.sortBy))
    paramMap.set(PARAMS.sortOrder, existsOrDefault(this.sortDesc, false) ? "desc" : "asc")
    paramMap.set(PARAMS.filterRaw,existsOrDefault(this.filtersQuery, []).join(";"))
    paramMap.set(PARAMS.demoUid, existsOrDefault(this.$store.getters.demoUid))
    paramMap.set(PARAMS.ab, existsOrDefault(this.$store.getters.ab))

    if (filter_arr){
        paramMap = new Map(
            [...paramMap].filter(([k, v]) => filter_arr.includes(k) )
        )
    }

    return paramMap

}


const emailListRegex = new RegExp(
    "^(\\w([-_+.']*\\w+)+@(\\w(-*\\w+)+\\.)+[a-zA-Z]{2,4}[,])*\\w([-_+.']*\\w+)+@(\\w(-*\\w+)+\\.)+[a-zA-Z]{2,4}$"
);

export default {getVariant, getDefaultTemplates, getParamMap, PARAMS, ROUTES, emailListRegex}


// WEBPACK FOOTER //
// ./src/util/defaults.js